import { apiRequest } from "api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { encryptPayload } from "./encrypt";
import { BASE_URL } from "constants/routes";

export const getUserListBySearchQuery = createAsyncThunk(
  "users/getUserListBySearchQuery",
  async (query) => {
    const req = `${BASE_URL}/users/getAllUsersList`;
    let params = {
      body: { search: query },
    };
    const encryptedBodyRes = await encryptPayload("", params, true, true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };
    try {
      const result = await encryptPayload(req, options, false, true, true);
      return result;
    } catch (error) {
      throw error;
    }
  }
);

